// extracted by mini-css-extract-plugin
export default {"root_scroller":"GW","flex_container":"HW","container":"IW","scroller":"JW","indicator":"KW","scrollButtons":"LW","selected":"MW","root_tab":"NW","root_tab_scrollable":"OW","root_scroller_mob":"PW","scroller_mob":"QW","indicator_mob":"RW","selected_mob":"SW","root_tab_mob":"TW","root_tab_mob_scrollable":"UW"};
    if(module.hot) {
      // 1714422957577
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  